import moduleEndpointIdSelector from 'root/src/client/logic/api/selectors/moduleEndpointIdSelector'
import apiRequest from 'root/src/client/logic/api/thunks/apiRequest'
import pathOr from 'ramda/src/pathOr'

export default (data, { moduleId }) => async (dispatch, getState) => {
	const state = getState()
	const endpointId = moduleEndpointIdSelector(state, { moduleId })
	const res = await dispatch(apiRequest(endpointId))
	const fileDownloadUrl = pathOr(undefined, ['body', 'fileUrl'], res)
	// eslint-disable-next-line no-alert,no-unused-expressions
	fileDownloadUrl ? window.open(fileDownloadUrl) : alert('This report is empty')
}
